import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import Category2productEditForm from './Category2productEditForm';
import Category2productList from './Category2productList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import Category2productListView from './Category2productListView'


export default function Category2productDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.category2productDashboard);
  const [ category2productId, setCategory2productId] = React.useState('');
  const [reloadCategory2productList, setReloadCategory2productList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <Category2productEditForm 
            setReloadCategory2productList={setReloadCategory2productList}
            category2productId={category2productId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <Category2productListView 
                      setCategory2productId = {setCategory2productId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
